module.exports = __webpack_public_path__ + "media/2.c24d0f6f.mp3";